import { Constants } from "../constants/constants";
import { EstimateTableRow } from "./EstimateObject";
import { TRRThresholds } from "./TRRThresholds";
export class DialogInputBase{
    message: string = '';
    title:string = '';
    titleClass: string = '';
}

export class DialogOutputBase{
    button: string = Constants.CANCEL;
}

export class DenyDialogOutput extends DialogOutputBase {
    comments: string = '';
}

export class TRRDialogInput{
    selectedRadioOption: string = '';
    trrThresholds: TRRThresholds = new TRRThresholds();
} 

export class TRRDialogOutput extends DialogOutputBase{
    selectedRadioOption: string = '';
}

export class UserLinkingDialogInput extends DialogInputBase{
    isCancelBtnNeeded: boolean = false;
}

export class ReleaseEditAccessDialogInput extends DialogInputBase{
    selectedRadioOption: string = '';
    row: EstimateTableRow = new EstimateTableRow();
}
export class ReleaseEditAccessDialogOutput extends DialogOutputBase{
    isDiscard: boolean = false;
    notes: string | null = null;
}